document.addEventListener("DOMContentLoaded", function () {
    initializeSwiperHeader();
        var menu_mob = document.querySelector("#menu-mobile")
        var overlay = document.querySelector(".overlay-bg")
        var close_menu_mob = document.querySelector("#close-menu-mobile")
        var toggle_btn = document.querySelector(".toggle-mob")
        var toggle_search = document.querySelector("#toggle-search")
        var search_form = document.querySelector("#search-form")
        var isSearchActive = false;
        
        toggle_btn.addEventListener("click", function () {
        handleMenuToggle(menu_mob, overlay, true)
      });

      toggle_search.addEventListener("click", function () {
        isSearchActive = !isSearchActive; 
        handleSearch(search_form, isSearchActive);
      });
      
    
      [close_menu_mob, overlay].forEach(function (el) {
        el.addEventListener("click", function (e) {
          handleMenuToggle(menu_mob, overlay, false);
        });
      });
})

function initializeSwiperHeader() {
    new Swiper(".swiper-top-bar", {
      loop: true,
      speed: 7000,
      autoplay: {
        delay: 12,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      watchSlidesProgress: true
    });
  }

function handleMenuToggle(menu, overlay, active) {
  if (active) {
    menu.classList.add("active");
    overlay.classList.add("active");
  } else {
    menu.classList.remove("active");
    overlay.classList.remove("active");
  }
}

function handleSearch(menu, active) {
    if (active) {
      menu.classList.add("!block");
    } else {
      menu.classList.remove("!block");
    }
  }
  
